import { Trash2 } from 'lucide-react';
import { FC } from 'react';

interface TrashAllFiltersProps {
  onClick: () => void;
  title?: string;
}

const TrashAllFilters: FC<TrashAllFiltersProps> = ({
  onClick,
  title = 'Limpiar filtros'
}) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className="inline-flex h-9 w-9 items-center justify-center rounded-full text-red-500 transition hover:scale-110 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300"
  >
    <Trash2 size={16} />
  </button>
);

export default TrashAllFilters;
